import {Fournisseur} from '@/models';

export default [
	{
		path: '/fournisseurs',
		name: 'fournisseurs',
		meta: {
			title: 'Liste des fournisseurs',
			granted: [ 'API_GET_FOURNISSEUR' ],
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/Fournisseur.vue')
	},
	{
		path: '/fournisseurs/show/:id',
		name: 'fournisseur-show',
		props: {
			slotData: () => ({
				component: import(/* webpackChunkName: "dashboard" */ '../components/Crud/Fournisseur/Show.vue'),
				class: Fournisseur
			}),
			editRoute: { name: 'fournisseur-edit' },
		},
		meta: {
			title: 'Détail d\'un fournisseur',
			granted: [ 'API_GET_FOURNISSEUR' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/EditShow.vue')
	},
	{
		path: '/fournisseurs/edit/:id',
		name: 'fournisseur-edit',
		props: {
			slotData: () => ({
				component: import(/* webpackChunkName: "dashboard" */ '../components/Crud/Fournisseur/Edit.vue'),
				class: Fournisseur
			}),
		},
		meta: {
			title: 'Edition d\'un fournisseur',
			granted: [ 'API_PUT_FOURNISSEUR' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/EditShow.vue')
	},
];
